module.exports = __webpack_public_path__ + "img/lock.9ae20e99.jpg";